import { EditOutlined, GlobalOutlined, NodeIndexOutlined, UserOutlined } from '@ant-design/icons';
import { Button, Col, Flex, Layout, Progress, Row, Space } from "antd";
import Sider from "antd/es/layout/Sider";
import { Content, Header } from "antd/es/layout/layout";
import { TaskDefCrudService } from '../../apis/mgmt/TaskDefCrudService';
import { AgentDef, ScheduledTaskDef, TaskDef } from "../../apis/mgmt/api";
import { AdapterDefSectionList, useAdapterDefListByAgent } from "../adapter/AdapterDefList";
import { Area } from '../common/Area';
import { EditableProps, useStatefulApiEditable } from "../common/Editable";
import { useListWithEditable } from "../common/List";
import { PageGoBack } from '../common/PageGoBack';
import { Section } from '../common/Section';
import { ToggleableProps, useStatefulToggleable } from "../common/Toggleable";
import { TaskDefEditable } from '../task/TaskDefEditable';
import { TaskDefSectionList, useTaskDefListByAgent } from '../task/TaskDefList';
import { Modal } from '../common/Modal';
import { TaskDefExecutions } from '../task/TaskDefExecutions';
import { useContext, useEffect, useState } from 'react';
import { Auth, Role } from '../../apis/Auth';
import { ScheduledTaskDefSectionList, useScheduledTaskDefListByAgent } from '../scheduledtask/ScheduledTaskDefList';
import { ScheduledTaskDefEditable } from '../scheduledtask/ScheduledTaskDefEditable';
import { ScheduledTaskDefCrudService } from '../../apis/mgmt/ScheduledTaskDefCrudService';

export const AgentAdaptersAndTasks = function (
    props: EditableProps<AgentDef> & {
        toggle?: ToggleableProps,
        editableForm: EditableProps<AgentDef>,
    }
) {

    const { is } = useContext(Auth);

    const { data } = props;
    const agentId = data?.id;

    const owners = data?.domains?.map(d => d.permissions || [])
    ?.reduce((acc, p) => acc.concat(p), [])
    ?.filter(p => p.role?.level === 'OWNER')
    ?.map((p, index, array) => (
        <span key={p.id} title={`${p.user?.phone} ${p.user?.email}`}>
        {[p.user?.firstName,p.user?.lastName].filter(n=>n).join(' ')}{index < array.length - 1 && ', '}
        </span>
    ));

    const { toggle } = props;
    const visible = toggle?.visible;

    ////
    // Task Defs
    const taskToggle = useStatefulToggleable(false);
    const { listProps: taskListProps, editableProps: taskEditableProps } = useListWithEditable<TaskDef>({
        listProps: useTaskDefListByAgent({ agentId })['listProps'],
        editableProps: useStatefulApiEditable(TaskDefCrudService, undefined, undefined, taskToggle),
        toggle: taskToggle,
        defaultAddItemData: { agentId },
    });

    const taskExecutionsToggle = useStatefulToggleable(false);
    const [ selectedTaskDef, setSelectedTaskDef ] = useState<TaskDef>();
    taskListProps.onSelectedItem = (item) => { 
        taskExecutionsToggle.show();
        setSelectedTaskDef(item);
    }
    useEffect(() => {
        if (!visible) {
            setSelectedTaskDef(undefined);
            taskExecutionsToggle.hide();
        }
    }, [visible]);

    ////
    // Scheduled Task Defs
    const scheduledToggle = useStatefulToggleable(false);
    const { listProps: scheduledListProps, editableProps: scheduledEditableProps } = useListWithEditable<ScheduledTaskDef>({
        listProps: useScheduledTaskDefListByAgent({ agentId })['listProps'],
        editableProps: useStatefulApiEditable(ScheduledTaskDefCrudService, undefined, undefined, scheduledToggle),
        toggle: scheduledToggle,
        defaultAddItemData: { taskDef: { agentId } },
    });

    return (
        <Layout className='h-100'>
            <Header>
                <PageGoBack onClick={toggle?.hide} />
            </Header>
            <Layout>
                <Layout>
                    <Header style={{ height: "auto" }}>
                        <Area>
                            <Layout>
                                <Content>
                                    <Flex className='h-100' vertical justify='space-around' >
                                        <span className="mig-title-1 mig-in-one-line">{data?.name}</span>
                                        <Flex gap="2em" align='center' >
                                            <span className="mig-in-one-line">
                                                <GlobalOutlined /> {data?.domains?.map((domain) => domain.slug).join(", ")}
                                            </span>
                                            { owners && owners.length && <span className="mig-in-one-line"><UserOutlined /> {owners}</span> || null }
                                        </Flex>
                                    </Flex>
                                </Content>
                                <Sider width="auto" collapsed={false} style={{ verticalAlign: 'middle' }}>
                                    <Space.Compact direction="vertical" >
                                        {is(Role.TECHNICIAN) && <Button style={{ textAlign: "left" }} type="text" onClick={()=>props.editableForm.edit(data)}><EditOutlined />Editar </Button>}
                                        <Button style={{ textAlign: "left" }} type="text"><NodeIndexOutlined />Matches</Button>
                                    </Space.Compact>
                                </Sider>
                            </Layout>
                        </Area>
                    </Header>
                    <Content>
                        <Area>
                            <Section>
                                <AdapterDefSectionList 
                                    listProps={useAdapterDefListByAgent({ agentId })['listProps']} 
                                    defaultAddItemData={{ agentId }}
                                />
                            </Section>
                            <Section><TaskDefSectionList listProps={taskListProps} /></Section>
                            <Section><ScheduledTaskDefSectionList listProps={scheduledListProps} /></Section>
                        </Area>
                    </Content>
                </Layout>

                <Sider width="500px" collapsedWidth={"0"} collapsed={!taskExecutionsToggle.visible}>
                    <TaskDefExecutions toggle={taskExecutionsToggle} data={selectedTaskDef} setData={setSelectedTaskDef} editable={taskEditableProps} />
                </Sider>

            </Layout>
            
            <Modal mode="FullPage" 
                title={taskEditableProps.data?.id? "Editando tarea" : "Nueva tarea"}
                toggle={taskToggle} onCancel={taskEditableProps.cancel}
            >
                <TaskDefEditable {...taskEditableProps} />
            </Modal>

            <Modal mode="FullPage" 
                title={scheduledEditableProps.data?.id? "Editando tarea programada" : "Nueva tarea programada"}
                toggle={scheduledToggle} onCancel={scheduledEditableProps.cancel}
            >
                <ScheduledTaskDefEditable {...scheduledEditableProps} />
            </Modal>

        </Layout>
    );

};
